// extracted by mini-css-extract-plugin
export default {"toggleBtn":"ThemeToggler_toggleBtn__jwzl9"};